export default {"src":"/_next/static/media/received.494734e9.svg","height":512,"width":512};